import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

// Jumps rather than scrolls, in the same task as the navigation, so the new page
// paints already at the top. A delayed smooth scroll first showed the new page
// at the old offset, then animated across it while its skeleton was swapped for
// content.
export const ScrollToTop = (): null => {
  const history = useHistory();

  useEffect(() => history.listen(() => window.scrollTo(0, 0)), [history]);

  return null;
};
